﻿$.fn.dxCtrlContentPlaniti = function custom_dxCtrlContentPlaniti(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcontentplaniti dx-ctrl");
        this.createInstance(new cdxCtrlContentPlaniti(this, option));
    }
    return this;
}

window.cdxCtrlContentPlaniti = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var dataAllPlaniti = null
    var ctrlResize = null
    function mConstruit() {
        container.empty();

        var jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow()
        option.bddCtrl.mAjaxCall({ command: "getdataplaniti", id_planiti: option.data.id_planiti }, function (data) {
            dataAllPlaniti = data
            dataAllPlaniti.planiti = dataAllPlaniti.planiti[0]

            if (dataAllPlaniti.planiti.ferme == "1") { container.addClass("texture_import_disable_projet_pipeline") }
            else { container.removeClass("texture_import_disable_projet_pipeline") }

            ctrlResize = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlSplitterResize2({
                bddCtrl: option.bddCtrl,
                context_grid: "splitterfile",
                widthLeftInitial: 250
            }).dxCtrlSplitterResize2("instance")

            ctrlResize.mConstruitLeft(function (contentElement) {
                var dxScroll = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                $("<div/>").appendTo(dxScroll.content()).dxCtrlContentPlanitiSaisie({
                    bddCtrl: option.bddCtrl,
                    data: dataAllPlaniti,
                    onValueChanged: function () {
                        mConstruitRight()
                    },
                    onValueChangedResume: function () {
                        dxPagePlanitiReuExt.mUpdateDetail()
                    },
                    onValueChangedHoraire: function () {
                        dxPagePlanitiReuExt.mUpdateHeure()
                    }
                })
                mConstruitRight()
                jauge.mHide()
            })

            mRempliBt()
        })
    }

    var dxPagePlanitiReuExt = null
    function mConstruitRight() {
        ctrlResize.mConstruitRight(function (contentElement) {
            contentElement.empty()
            dxPagePlanitiReuExt = $("<div/>").appendTo(contentElement).dxCtrlPagePlanitiReunionExterne({
                bddCtrl: option.bddCtrl,
                //isInterne:true,
                dataPlaniti: dataAllPlaniti
            }).dxCtrlPagePlanitiReunionExterne("instance")
        })
    }

    var lstItemToolBarSource = null
    function mRempliBt() {
        if (typeof option.optionPopup == 'undefined') option.optionPopup = {}
        if (typeof option.optionPopup.toolbar == 'undefined' || option.optionPopup.toolbar == null) {
            option.optionPopup.toolbar = $("<div/>").appendTo(container).dxToolbar({
                width: "100%",
                items: [],
                onContentReady: function (e) {
                    e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
                }
            }).dxToolbar("instance")
        } else {
            var lstIt = option.optionPopup.toolbar.option("items")
            var lstDel = []
            lstIt.forEach(function (it) { if (it.cssClass != "initial") lstDel.push(it) })
            lstDel.forEach(function (it) { lstIt.splice(lstIt.indexOf(it), 1) })
            option.optionPopup.toolbar.option("items", lstIt)
        }

        var itemsToolbar = []
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-arrow-up-right-from-square",
                    hint: "Naviguer vers la page de réservation",
                    onClick: function (e) {
                        window.open(parametre.url_appli + "/" + option.bddCtrl.nom_base + "/"  + dataAllPlaniti.planiti.id_planiti + "/0/0/0/0/planiti","_blank")
                    }
                })
            },
        })
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-copy",
                    hint: "Copier le lien vers la page de réservation",
                    onClick: function (e) {
                        var $temp = $("<input>");
                        $("body").append($temp);
                        $temp.val(parametre.url_appli + "/" + option.bddCtrl.nom_base + "/" + dataAllPlaniti.planiti.id_planiti + "/0/0/0/0/planiti").select();
                        document.execCommand("copy");
                        $temp.remove();
                        mNotify("Le lien a été copié dans le presse papier.", "success", 6000)
                    }
                })
            },
        })
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-refresh",
                    hint: "Rafraichir la vue de l'évènement",
                    onClick: function (e) {
                        dxPagePlanitiReuExt.mUpdate()
                    }
                })
            },
        })
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                var $Table = $("<table/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td/>").appendTo($Tr)
                $("<div style=''/>").appendTo($Td).dxCtrlSwitch({
                    txtTooltip: "Fermer l'évènement",
                    value: (dataAllPlaniti.planiti.ferme=="1"),
                    onValueChanged: function (e) {
                        dataAllPlaniti.planiti.ferme = ((e.value) ? "1" : "0")
                        option.bddCtrl.getObjet(dataAllPlaniti.planiti).mSaveChamp("ferme")
                        if (dataAllPlaniti.planiti.ferme == "1") { container.addClass("texture_import_disable_projet_pipeline") }
                        else { container.removeClass("texture_import_disable_projet_pipeline") }
                        dxPagePlanitiReuExt.mUpdate()
                    }
                });
                var $Td = $("<td style='opacity:" + ((dataAllPlaniti.planiti.ferme == "1") ? "1" : "0.2") + "'>Fermé</td>").appendTo($Tr)
            },
        })

        itemsToolbar.reverse()
        if (!lstItemToolBarSource) lstItemToolBarSource = option.optionPopup.toolbar.option("items").slice()
        var lstItems = lstItemToolBarSource.slice()
        itemsToolbar.forEach(function (itemT) { lstItems.unshift(itemT) })
        option.optionPopup.toolbar.option("items", lstItems)
    }


    this.element = function () { return container; }

    mConstruit();
}